import { useFlagsStatus } from '@unleash/proxy-client-react';
import { SentryService } from 'libs/sdk/src/lib/sentry';
import { lazy, useEffect } from 'react';

import { FullPageLoader } from './components/Loaders';

import { useFeatureFlag, useHubspot } from '@/hooks';
import { useProfile } from '@/store';

const AppView = lazy(() => import('@/views').then(module => ({ default: module.AppView })));
const PublicView = lazy(() => import('@/views').then(module => ({ default: module.PublicView })));
const MaintenanceView = lazy(() =>
  import('@/views').then(module => ({ default: module.MaintenanceView }))
);

export const App = () => {
  const {
    profile,
    isLoading,
    roleCheck: { isStudent, isTeacher }
  } = useProfile();

  const isMaintenanceMode = useFeatureFlag('MAINTENANCE_MODE');
  const { flagsReady } = useFlagsStatus();

  const { init: initHubspot } = useHubspot();

  useEffect(() => {
    if (profile) {
      SentryService.initialize(profile, import.meta.env.PROD);
      initHubspot(profile);
    }
  }, [profile?._id]);

  if (isLoading || !flagsReady) return <FullPageLoader />;

  if (profile) {
    if (isMaintenanceMode && (isStudent || isTeacher)) return <MaintenanceView />;
    return <AppView />;
  }

  return <PublicView />;
};

export default App;
